// extracted by mini-css-extract-plugin
module.exports = {"visibleMobile":"VenueDetails--visibleMobile","taCenter":"VenueDetails--taCenter","hiddenMobile":"VenueDetails--hiddenMobile"};